import script from "./AllChatProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AllChatProduct.vue?vue&type=script&setup=true&lang=js"

import "./AllChatProduct.vue?vue&type=style&index=0&id=758c23da&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758c23da"]])

export default __exports__